export class EligibilityModalResultKeys {
    static readonly PROVINCE = 'form_modal_eligibility_province';
    static readonly SPECIALIST_GROUP = 'form_modal_eligibility_role';

    static readonly FIRST_NAME = 'form_modal_eligibility_first_name';
    static readonly LAST_NAME = 'form_modal_eligibility_last_name';
    static readonly EMAIL = 'form_modal_eligibility_email';
}

export interface IEligibilityModalFormResultModel {
    form_modal_eligibility_province: string;
    form_modal_eligibility_role: string;

    form_modal_eligibility_first_name: string;
    form_modal_eligibility_last_name: string;
    form_modal_eligibility_email: string;
}
